import ProjectComponent from './project.component'

export default ProjectComponent
